"use client";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const EditProfile = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);

    const [formData, setFormData] = useState({
        full_name: "",
        company_name: "",
        email: "",
        phone_number: "",
    });

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem("accessToken");

            const res = await axios.get(
                "https://logicx.premierlam.com/api/pixel-get-profile-data",
                { headers: { authorization: token } }
            );

            const user = res?.data?.data?.[0];

            if (user) {
                const newData = {
                    full_name: user.full_name || "",
                    company_name: user.companyName || "",
                    email: user.companyEmail || "",
                    phone_number: user.CompanyPhone || "",
                };
                setFormData(newData);
                localStorage.setItem("personalInfo", JSON.stringify(user));
            }
        } catch (err) {
            console.error(err);
            toast.error("Failed to load profile details");
        } finally {
            setFetching(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/^[0-9]{10}$/.test(formData.phone_number)) {
            toast.error("Enter valid 10-digit mobile number");
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("accessToken");

            await axios.post(
                "https://logicx.premierlam.com/api/pixel_edit-profile-data",
                {
                    full_name: formData.full_name,
                    company_name: formData.company_name,
                    phone_number: formData.phone_number,
                },
                { headers: { authorization: token } }
            );

            toast.success("Profile updated successfully!");

            const updated = await axios.get(
                "https://logicx.premierlam.com/api/pixel-get-profile-data",
                { headers: { authorization: token } }
            );

            localStorage.setItem("personalInfo", JSON.stringify(updated.data.data[0]));

            // Redirect based on role
            const role = localStorage.getItem("userRole");

            setTimeout(() => {
                if (role === "vendor") {
                    navigate("/vendor-dashboard");
                } else if(role === "admin" || role === "super") {
                    navigate("/dashboard");
                }
            }, 1200);
        } catch (err) {
            console.error("Error updating:", err);
            toast.error("Update failed");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    return (
        <>
            <ToastContainer />
            <div className="min-h-screen bg-gray-100 p-4">
                <div className="max-w-4xl mx-auto bg-white rounded-lg p-6 shadow-sm border">

                    <h1 className="text-2xl font-semibold text-gray-800 mb-2">Edit Profile</h1>
                    <p className="text-gray-500 mb-6">Update your account information</p>

                    {fetching ? (
                        <div className="text-center py-10 text-gray-500">Loading profile...</div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-8">

                            {/* TWO FIELDS PER ROW */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                <div>
                                    <label className="block text-sm font-medium mb-1">Full Name</label>
                                    <input
                                        type="text"
                                        name="full_name"
                                        value={formData.full_name}
                                        onChange={handleChange}
                                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-500"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">Company Name</label>
                                    <input
                                        type="text"
                                        name="company_name"
                                        value={formData.company_name}
                                        onChange={handleChange}
                                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-500"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">Email</label>
                                    <input
                                        type="email"
                                        value={formData.email}
                                        disabled
                                        className="w-full p-2 border rounded-md bg-gray-100 cursor-not-allowed"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">Phone Number</label>
                                    <input
                                        type="text"
                                        name="phone_number"
                                        maxLength={10}
                                        value={formData.phone_number}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                phone_number: e.target.value.replace(/\D/g, "")
                                            }))
                                        }
                                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-500"
                                    />
                                </div>

                            </div>

                            {/* BUTTONS */}
                            <div className="flex justify-end gap-4">
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="px-6 py-2 border rounded-md"
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className={`px-6 py-2 rounded-md text-white ${loading ? "bg-gray-400" : "bg-orange-500 hover:bg-orange-600"
                                        }`}
                                >
                                    {loading ? "Saving..." : "Save Changes"}
                                </button>
                            </div>

                        </form>
                    )}
                </div>
            </div>
        </>
    );
};

export default EditProfile;
